import * as Types from '../../generated-types';

import { GraphQLClient } from 'graphql-request';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
export type UpdateUserRewardCoinsMutationVariables = Types.Exact<{
  userId: Types.Scalars['ID'];
  rewardCoins: Types.Scalars['Int'];
}>;


export type UpdateUserRewardCoinsMutation = { __typename?: 'Mutation', updateUsersPermissionsUser: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUser', documentId: string, firstName: string, lastName: string, rewardCoins?: number | null } | null } };


export const UpdateUserRewardCoinsDocument = `
    mutation UpdateUserRewardCoins($userId: ID!, $rewardCoins: Int!) {
  updateUsersPermissionsUser(id: $userId, data: {rewardCoins: $rewardCoins}) {
    data {
      documentId
      firstName
      lastName
      rewardCoins
    }
  }
}
    `;
export const useUpdateUserRewardCoinsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateUserRewardCoinsMutation, TError, UpdateUserRewardCoinsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateUserRewardCoinsMutation, TError, UpdateUserRewardCoinsMutationVariables, TContext>(
      ['UpdateUserRewardCoins'],
      (variables?: UpdateUserRewardCoinsMutationVariables) => fetcher<UpdateUserRewardCoinsMutation, UpdateUserRewardCoinsMutationVariables>(client, UpdateUserRewardCoinsDocument, variables, headers)(),
      options
    );